var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCoursePoliticalScience = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 98,
    viewBox: "0 0 105 98",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 104,
    height: 98,
    rx: 10,
    fill: "url(#paint0_linear_4258_313357)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8682,
    y: 72.8867,
    width: 50.6316,
    height: 1.64873,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7788 53.1219V59.7067H78.4997V61.3555H27.8682V59.7067H33.5792V53.1219H34.3964V52.2975C34.3964 44.4761 39.1207 37.7505 45.8384 34.8552V30.0497H52.3667V23.4648H54.0012V30.0497H60.5295V34.8652C67.2472 37.7505 71.9615 44.4761 71.9615 52.2975V53.1219H72.7788ZM47.4624 31.6982H47.4524V34.2417C49.2564 33.6586 51.18 33.3369 53.1734 33.3369C55.1668 33.3369 57.0904 33.6586 58.8944 34.2417V31.6982H47.4624ZM36.0309 52.2977C36.0309 42.7572 43.7253 34.9961 53.1839 34.9961C62.6424 34.9961 70.3368 42.7572 70.3368 52.2977V53.1221H36.0309V52.2977ZM35.2147 59.7069H71.1452V54.7607H35.2147V59.7069Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.3662,
    y: 62.1797,
    width: 1.63456,
    height: 9.88233,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62.9805,
    y: 62.1797,
    width: 1.63456,
    height: 9.88233,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5967,
    y: 62.1797,
    width: 1.63456,
    height: 9.88233,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 41.752,
    y: 62.1797,
    width: 1.63456,
    height: 9.88233,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31.1367,
    y: 62.1797,
    width: 1.63456,
    height: 9.88233,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 52.3662,
    y: 56.4092,
    width: 1.63456,
    height: 1.64873,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 57.2705,
    y: 56.4092,
    width: 1.63456,
    height: 1.64873,
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 62.165,
    y: 56.4092,
    width: 1.63456,
    height: 1.64873,
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 67.0674,
    y: 56.4092,
    width: 1.63456,
    height: 1.64873,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 47.4629,
    y: 56.4092,
    width: 1.63456,
    height: 1.64873,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 42.5703,
    y: 56.4092,
    width: 1.63456,
    height: 1.64873,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 37.665,
    y: 56.4092,
    width: 1.63456,
    height: 1.64873,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4258_313357",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11CDAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B299"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCoursePoliticalScience, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CoursePoliticalScience.47e7b5ff.svg";
export { ForwardRef as ReactComponent };